export default "__VITE_ASSET__8C2wAn4M__"